module.exports = __webpack_public_path__ + "img/case-logo-32.af28c90a.png";